export const excludedProjectFieldsForFilter = [
  'estimatedDueDate',
  'currentPhases',
];

export const projectFinancialFields = [
  'projectBudget',
  'financialContractType',
  'actualRevenue',
  'actualCost',
  'actualProfit',
  'actualProfitMargin',
  'percentageBudgetConsumed',
  'percentageBudgetedHoursConsumed',
  'estimateToComplete',
  'estimateAtCompletion',
  'subscriptionFrequency',
  'numberOfPeriods',
];

export const excludedProjectFieldsForFilterInDashboard =
  excludedProjectFieldsForFilter.concat(projectFinancialFields);

export const excludedProjectFieldsForPeoplePerformanceReport = [
  'startDate',
  'dueDate',
];
